export const MEDIUM_DATE_FORMAT = "MM/dd/yyyy";
export const SHORT_DATE_FORMAT = "MM/dd";
export const LONG_DATE_FORMAT = "MMMM dd, yyyy";
export const SERVER_DATE_FORMAT = "yyyy-MM-dd";

export const ADMIN_ROLE = Symbol.for("PT Admin User");
export const VENDOR_ROLE = Symbol.for("Vendor User");
export const CLIENT_ROLE = Symbol.for("Client User");
export const UNKNOWN_ROLE = Symbol.for("Unknown Role");

export const CLIENT_TIMEOUT = "Client Timeout";
export const SERVER_TIMEOUT = "Server Timeout";
export const CLIENT_ERROR = "Client Error";
export const SERVER_ERROR = "Server Error";
export const UNKNOWN_ERROR = "Unknown Error";

//Unique identifiers for saving user preferences for data tables
//Needs to match value in vp/AttestationExportService.TABLE_COLUMNS_PREFERENCE_KEY
export const VENDOR_ATTESTATIONS_TABLE = "vendor-attestations-table";

//Reports
export const SALESFORCE_INVOICE_EXPORT = {
  identifier: "salesforceInvoiceReportService",
  name: "Salesforce Invoice Export"
};
export const VENDOR_EXPORT_ONE_ORGANIZATION = {
  identifier: "vendorExportOneOrganizationService",
  name: "Vendor Export One Organization",
  parameters: [
    {
      identifier: "clientId",
      name: "Client ID",
      type: "text",
      instructions: `Client IDs can be looked up on this page:
        <a href="/admin/manage/clients" target="_blank">Manage Clients</a>
        (It will open in a new tab)`
    }
  ]
};
export const VENDOR_NAMES_FOR_BILLING = {
  identifier: "vendorNamesForBillingService",
  name: "Vendor Names for Billing",
  parameters: [
    {
      identifier: "clientId",
      name: "Client ID",
      type: "text",
      default: 136,
      instructions: `Client IDs can be looked up on this page:
        <a href="/admin/manage/clients" target="_blank">Manage Clients</a>
        (It will open in a new tab)<br />The default ID of 136 is for CHS.`
    },
    {
      identifier: "dateRange",
      name: "Date Range",
      type: "date",
      default: [
        // First day of the Previous Month
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
          .toISOString()
          .slice(0, 10),

        // Last day of the Previous Month
        new Date(new Date().getFullYear(), new Date().getMonth(), 0)
          .toISOString()
          .slice(0, 10)
      ],
      instructions: "The date range defaults to the previous month."
    }
  ]
};

export const ADMIN_REPORTS = [
  SALESFORCE_INVOICE_EXPORT,
  VENDOR_EXPORT_ONE_ORGANIZATION,
  VENDOR_NAMES_FOR_BILLING
];
